import { render, staticRenderFns } from "./EntrySheetEduHistoryCard.vue?vue&type=template&id=31cc8ed7"
import script from "./EntrySheetEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EntrySheetEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports